import { z } from 'zod';
import { defineListQuery } from './list-query.schemas';

/**
 * The tyre brand and tyre size catalogues (gitaumoses4/chukua#420): the values a tyre's brand and size are picked from,
 * which an admin extends from the tyre form. A tyre points at its entry, so "Michelin" and "michelin " are one brand.
 * Deactivated, never deleted: tyres point at them. Limits match the free-text columns they replace.
 */

/** `POST /tyre-brands`. The code is the lowercased name with whitespace collapsed, as with the part types. */
export const tyreBrandInputSchema = z.object({ name: z.string().trim().min(1).max(80) }).strict();
export type TyreBrandInput = z.infer<typeof tyreBrandInputSchema>;

/** `POST /tyre-sizes`. */
export const tyreSizeInputSchema = z.object({ name: z.string().trim().min(1).max(40) }).strict();
export type TyreSizeInput = z.infer<typeof tyreSizeInputSchema>;

const catalogueListQuery = {
  sortFields: ['name'],
  defaultSort: { sort: 'name', order: 'asc' },
  filters: {
    isActive: z
      .enum(['true', 'false'])
      .transform((value) => value === 'true')
      .optional(),
  },
} as const;

export const tyreBrandListQuerySchema = defineListQuery(catalogueListQuery);
export type TyreBrandListQuery = z.output<typeof tyreBrandListQuerySchema>;

export const tyreSizeListQuerySchema = defineListQuery(catalogueListQuery);
export type TyreSizeListQuery = z.output<typeof tyreSizeListQuerySchema>;

export interface TyreBrandView {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
}

export interface TyreSizeView {
  id: string;
  code: string;
  name: string;
  isActive: boolean;
}
